import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ChatChevronIcon(props: SimpleIconInterface): JSX.Element {
  const { stroke = IconColors.DarkGrey, ...rest } = props;
  return (
    <SimpleIcon
      {...rest}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      viewBoxDimensions="0 0 24 24"
    >
      <path d="M9 6l6 6l-6 6" fill="none" />
    </SimpleIcon>
  );
}
